import { Box, Grid, styled } from '@mui/material'
import { Button, Typography } from '@carto/meridian-ds/components'
import { useAppSelector } from 'app/state'
import { useState, useEffect, ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { ArrowForward } from '@mui/icons-material'
import { WorkflowEmptyCardProps } from 'features/workflows/types'
import BGImage from 'assets/img/grid.webp'
import useUserRoles from 'features/account/state/useUserRoles'
import { useHardQuotaModalController } from 'features/quotas/ui/WouldExceedQuotaDialog'
import { useAccountQuotas } from 'features/quotas/ui/hooks'
import WorkflowEmptyCard from './WorkflowEmptyCard'

const emptyCardsImgs = [BGImage, BGImage, BGImage, BGImage]

const TitleContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(3, 0),
  display: 'flex',
  justifyContent: 'space-between'
}))

export function HomeWorkflows({
  workflowsLength,
  title,
  children,
  emptyWorkflowWithButton,
  isOnboarding = false
}: {
  workflowsLength: number
  title?: ReactNode
  children: ReactNode
  emptyWorkflowWithButton?: boolean
  isOnboarding?: boolean
}) {
  const stats = useAppSelector((state) => state.account.statsData.stats)
  const hasWorkflows = (stats?.totalWorkflows || 0) > 0
  const [totalWorkflowsToShow, setTotalWorkflowsToShow] = useState<number>(0)
  const { userIsViewer } = useUserRoles()
  const { workflowsQuota } = useAccountQuotas()
  const hardQuotaModalController = useHardQuotaModalController(workflowsQuota)

  useEffect(() => {
    setTotalWorkflowsToShow(4)
  }, [])

  const showPlaceholders = workflowsLength === 0 ? true : workflowsLength < totalWorkflowsToShow && !userIsViewer

  const emptyCards = (cardsNumber: number) => {
    const emptyCards: WorkflowEmptyCardProps[] = []

    for (let i = 0; i < cardsNumber; i++) {
      if (hardQuotaModalController.additionWouldExceedQuota()) {
        hardQuotaModalController.open()
        return
      }
      emptyCards.push({
        onClick: () => {
          window.open('/workflows/', '_blank', 'noopener,noreferrer')
        },
        img: emptyCardsImgs[i]
      })
    }
    return emptyCards
  }

  return (
    <Box mb={8}>
      <TitleContainer>
        <Typography variant="h6">
          {title ? title : <FormattedMessage id="home.actions.lastWorkflows.title" />}
        </Typography>
        {hasWorkflows && (
          <Button color="primary" component={NavLink} to="/workflows" size="small" endIcon={<ArrowForward />}>
            <FormattedMessage id="home.actions.lastWorkflows.all" />
          </Button>
        )}
      </TitleContainer>
      <Grid container spacing={3}>
        {[
          ...(!isOnboarding ? [children] : []),
          ...(showPlaceholders
            ? emptyCards(totalWorkflowsToShow - workflowsLength)?.map((card, key) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                  <WorkflowEmptyCard card={card} withButton={key === 0 && !children ? true : emptyWorkflowWithButton} />
                </Grid>
              )) ?? []
            : []),
          ...(isOnboarding ? [children] : [])
        ]}
      </Grid>
    </Box>
  )
}

export default HomeWorkflows
